export default (unauthenticated) => [
  {
    path: 'usuario',
    name: 'Termos do usuário',
    component: () => import('@components/Terms/TermsUser')
  },
  {
    path: 'parceria',
    name: 'Termos de parceria',
    component: () => import('@components/Terms/TermsPartner')
  },
  {
    path: 'privacidade',
    name: 'Política de privacidade',
    component: () => import('@components/Terms/TermsPrivacy')
  }

].map(({ name, ...term }) => ({
  ...term,
  name: name + (!unauthenticated ? ' logado' : ''),
  meta: {
    label: name,
    unauthenticated
  }
}))



// WEBPACK FOOTER //
// ./src/router/routes/terms.js